<div class="column" [style.gap.px]="gapSize" *ngFor="let y of yCord">
  <div class="square" [ngClass]="{'square--disabled': disabled}" *ngFor="let x of xCord" (click)="onCellClick(x, y)">
    <div class="bee-wrapper">
      <img
        class="bee"
        [ngClass]="{
          'bee--current': beePosition.x === x && beePosition.y === y,
          'bee--disabled': disabled
        }"
        src="assets/images/games/bee/bee.gif"
      />
    </div>
  </div>
</div>
